import { createContext, FC, useState } from 'react'

export type Data = {
  id?: string
  title: string
  description: string
  category: string
  url: string
  cycle: string
  image?: File
  image_description?: File
  active: boolean
}
export interface DataContext {
  formData: Data,
  handleChangeFormData: (data: Partial<Data>) => void,
  handleUpdateFormData: (data: Partial<Data>) => void,
}

const initialData: Data = {
  id: '',
  title: '',
  description: '',
  category: '',
  cycle: '',
  image: undefined,
  image_description: undefined,
  url: '',
  active: true,
}

export const Context = createContext<DataContext>({
  formData: initialData,
  handleChangeFormData: (data: Partial<Data>) => {},
  handleUpdateFormData: (data: Partial<Data>) => {},
})

const OffersFormDataProvider: FC = (props) => {
  const [formData, setFormData] = useState<Data>(initialData)

  const handleChangeFormData = (data: Partial<Data>) =>
    setFormData({ ...formData, ...data })

  const handleUpdateFormData = (data: Partial<Data>) => {
    if (data && data?.id) {
      setFormData({
        ...formData,
        id: data.id,
        title: data.title || initialData.title,
        description: data.description || initialData.description,
        url: data.url || initialData.url,
        category: data.category || initialData.category,
        cycle: data.cycle || initialData.cycle,
        image: data.image || initialData.image,
        image_description: data.image_description || initialData.image_description,
        active: data.active || false
      })
    }
  }
  return (
    <Context.Provider value={{ formData, handleChangeFormData, handleUpdateFormData }}>
      {props.children}
    </Context.Provider>
  )
}

export default OffersFormDataProvider
